import * as React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SideMenu from './Components/Account_registration/SideMenu';

const AccountRegistration=()=>{
return(
    <MainCard  sx={{height:'80vh',overflowX:'scroll',overflowY:'scroll'}}>
        <SideMenu />
    </MainCard>
)
}

export default AccountRegistration